import 'core-js/stable';
import 'regenerator-runtime/runtime';
import './tailwind.css';
import '@mdi/font/css/materialdesignicons.css';
import './assets/fonts/font.scss';
import 'viralstyle-ui/src/stylesheets/default/_index.scss';

import Vue from 'vue';
import VueLazyload from 'vue-lazyload';
import VueTouch from 'vue-touch';
import VueIntercom from 'vue-intercom';
import PortalVue from 'portal-vue'
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

import config from 'config';
import App from './App';
import router from './router';
import store from './store';

import loadingGif from './assets/images/ring.gif';
import packageJson from '@/../package.json';

if (config.RAVEN_URL) {
  Sentry.init({
    dsn: config.RAVEN_URL,
    integrations: [
      new Integrations.Vue({ Vue, attachProps: true }),
      new Sentry.Integrations.GlobalHandlers({
        onerror: true,
        onunhandledrejection: false,
      }),
    ],
    release: packageJson.version,
    environment: process.env.NODE_ENV
  });
}

Vue.use(VueTouch, { name: 'v-touch' });

Vue.use(VueLazyload, {
  // preLoad: 1.3,
  // error: 'dist/error.png',
  loading: loadingGif,
  attempt: 1,
});

Vue.use(VueIntercom, { appId: config.INTERCOM_ID });

Vue.config.keyCodes = {
  comma: 188,
};

Vue.use(PortalVue);

// init
new Vue({
  el: 'body',
  router,
  store,
  render: h => h(App)
});

String.prototype.capitalize = function() {
  return this.charAt(0).toUpperCase() + this.toLowerCase().slice(1);
};

window.addEventListener('unhandledrejection', response => {
  response.preventDefault();

  Sentry.withScope(scope => {
    if (!response.reason) {
      if (config.RAVEN_URL) {
        scope.setExtra('response', JSON.stringify(response));

        Sentry.captureException(new Error('Unhandled Rejection: No Reason'));
      } else {
        console.error(response);
      }
    } else if (!response.reason.logged && !response.reason.requiresLogin && response.reason.status !== 404) {
      if (config.RAVEN_URL) {
        if (response.reason.message) {
          scope.setExtra('response', JSON.stringify(response));

          Sentry.captureException(new Error(`Unhandled Rejection: ${response.reason.message}`));
        } else {
          scope.setExtra('response', JSON.stringify(response));

          Sentry.captureException(new Error('Unhandled Rejection: No Message'));
        }
      } else {
        console.error(response);
      }
    }
  });
});

// polyfill map for dropzone... IE11?
FileList.prototype.map = function(callback) {
  return Array.from(this).map(callback)
};